import { useTheme } from '@fluentui/react';
import * as React from 'react';
import { CorptaxThemeContext } from '../contexts/corptaxThemeContext';
import { ALL_FLUENT_THEME_PROPERTIES, BaseTheme } from '../data-types/styles/BaseTheme';

export function useCorptaxTheme<T extends BaseTheme>(): T {
    const context = React.useContext(CorptaxThemeContext as unknown as React.Context<T>);
    if (!context) {
        throw new Error('useCorptaxTheme must be wrapped in a CorptaxThemeProvider');
    }
    const theme = useTheme();

    for (const prop in context) {
        if (!ALL_FLUENT_THEME_PROPERTIES.includes(prop)) {
            Object.defineProperty(theme, prop, { value: context[prop] });
        }
    }

    return theme as T;
}
